import React from "react";
import {
  AppstoreOutlined,
  MailOutlined,
  ReadOutlined,
  BankOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Radio, Menu, Popover } from "antd";

export const courseNames = [
  {
    key: "sub1",
    icon: <ReadOutlined />,
    label: (
      <Link
        to={
          "/courses?category=secondary_education&price=all&level=all&language=all&rating=all&sort_by=newest"
        }
        className="link"
      >
        Secondary Education
      </Link>
    ),
    children: [
      {
        key: "1",
        label: (
          <Link
            to={
              "/courses?category=class1&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            {" "}
            Class1
          </Link>
        ),
      },
      {
        key: "2",
        label: (
          <Link
            to={
              "/courses?category=class2&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class2
          </Link>
        ),
      },
      {
        key: "3",
        label: (
          <Link
            to={
              "/courses?category=class3&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class3
          </Link>
        ),
      },
      {
        key: "4",
        label: (
          <Link
            to={
              "/courses?category=class4&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class4
          </Link>
        ),
      },
      {
        key: "5",
        label: (
          <Link
            to={
              "/courses?category=class5&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class5
          </Link>
        ),
      },
      {
        key: "6",
        label: (
          <Link
            to={
              "/courses?category=class6&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class6
          </Link>
        ),
      },
      {
        key: "7",
        label: (
          <Link
            to={
              "/courses?category=class7&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class7
          </Link>
        ),
      },
      {
        key: "8",
        label: (
          <Link
            to={
              "/courses?category=class8&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class8
          </Link>
        ),
      },
      {
        key: "9",
        label: (
          <Link
            to={
              "/courses?category=class9&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class9
          </Link>
        ),
      },
      {
        key: "10",
        label: (
          <Link
            to={
              "/courses?category=class10&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class10
          </Link>
        ),
      },
      {
        key: "11",
        label: (
          <Link
            to={
              "/courses?category=class11&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class11
          </Link>
        ),
      },
      {
        key: "12",
        label: (
          <Link
            to={
              "/courses?category=class12&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            Class12
          </Link>
        ),
      },
    ],
  },

  {
    key: "sub2",
    icon: <BankOutlined />,
    label: (
      <Link
        to={
          "/courses?category=higher_and_technical_education&price=all&level=all&language=all&rating=all&sort_by=newest"
        }
        className="link"
      >
        Higher & Technical Education
      </Link>
    ),
    children: [
      {
        key: "13",
        label: (
          <Link
            to={
              "/courses?category=1st_year/BA/BSC/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            1st year(BA/BSC/Technical Edu)
          </Link>
        ),
      },
      {
        key: "14",
        label: (
          <Link
            to={
              "/courses?category=2nd_year/BA/BSC/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            2nd year(BA/BSC/Technical Edu)
          </Link>
        ),
      },
      {
        key: "15",
        label: (
          <Link
            to={
              "/courses?category=3rd_year/BA/BSC/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            3rd year(BA/BSC/Technical Edu)
          </Link>
        ),
      },
      {
        key: "16",
        label: (
          <Link
            to={
              "/courses?category=4th_year/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            4th year(Technical Edu)
          </Link>
        ),
      },
      {
        key: "17",
        label: (
          <Link
            to={
              "/courses?category=5th_year/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            5th year(Technical Edu)
          </Link>
        ),
      },
      {
        key: "18",
        label: (
          <Link
            to={
              "/courses?category=1st_year_pg/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            1st Year PG
          </Link>
        ),
      },
      {
        key: "19",
        label: (
          <Link
            to={
              "/courses?category=2nd_year_pg/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest"
            }
            className="link"
          >
            2nd Year PG
          </Link>
        ),
      },
    ],
  },
];

export const itemsForCoursesPage = [
  {
    key: "sub1",
    icon: <MailOutlined />,
    label: "Secondary Education",

    children: [
      {
        key: "1",
        label: <Radio>Class1</Radio>,
        link: "/courses?category=class1&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "2",
        label: <Radio>Class2</Radio>,
        link: "/courses?category=class2&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "3",
        label: <Radio>Class3</Radio>,
        link: "/courses?category=class3&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "4",
        label: <Radio>Class4</Radio>,
        link: "/courses?category=class4&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "5",
        label: <Radio>Class5</Radio>,
        link: "/courses?category=class5&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "6",
        label: <Radio>Class6</Radio>,
        link: "/courses?category=class6&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "7",
        label: <Radio>Class7</Radio>,
        link: "/courses?category=class7&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "8",
        label: <Radio>Class8</Radio>,
        link: "/courses?category=class8&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "9",
        label: <Radio>Class9</Radio>,
        link: "/courses?category=class9&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "10",
        label: <Radio>Class10</Radio>,
        link: "/courses?category=class10&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "11",
        label: <Radio>Class11</Radio>,
        link: "/courses?category=class11&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "12",
        label: <Radio>Class12</Radio>,
        link: "/courses?category=class12&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
    ],
  },
  {
    key: "sub2",
    icon: <AppstoreOutlined />,
    label: "Higher & Technical Education",
    link: "/courses?category=higher_and_technical_education&price=all&level=all&language=all&rating=all&sort_by=newest",
    children: [
      {
        key: "13",
        label: "1st year(BA/BSC/Technical Edu)",
        link: "/courses?category=1st_year/BA/BSC/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "14",
        label: "2nd year(BA/BSC/Technical Edu)",
        link: "/courses?category=2nd_year/BA/BSC/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "15",
        label: "3rd year(BA/BSC/Technical Edu)",
        link: "/courses?category=3rd_year/BA/BSC/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "16",
        label: "4th year(Technical Edu)",
        link: "/courses?category=4th_year/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "17",
        label: "5th year(Technical Edu)",
        link: "/courses?category=5th_year/technical_edu&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "18",
        label: "1st Year PG",
        link: "/courses?category=1st_year_pg&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
      {
        key: "19",
        label: "2nd Year PG",
        link: "/courses?category=2nd_year_pg&price=all&level=all&language=all&rating=all&sort_by=newest",
      },
    ],
  },
];

// export const image_base_url = `http://147.93.103.76:8080/lms/images/files/`;
// export const course_image_base_url = `http://147.93.103.76:8080/lms/images/files/uploads/`;

export const image_base_url = `https://backend.taggeo.net/lms/images/files/`;
export const course_image_base_url = `https://backend.taggeo.net/lms/images/files/uploads/`;
